import { PluginTFunction } from '../../utils';
import { ExpiryOptions } from '../ConditionalLinks/utils/linkInternalTypes';
import { DEFAULT_EXPIRATION_DAYS } from '../constants';

export const getExpiryOptions = (
	availableExpiryOptions: number[],
	t: PluginTFunction,
	selectedExpiry: number
): ExpiryOptions[] => {
	const expiryLabels: { [key: number]: string } = {
		[-1]: t('AccessOptions.expiresOptions.never'),
		[365]: t('AccessOptions.expiresOptions.after1year'),
		[183]: t('AccessOptions.expiresOptions.after6months'),
		[90]: t('AccessOptions.expiresOptions.after3months'),
		[30]: t('AccessOptions.expiresOptions.after30days'),
		[14]: t('AccessOptions.expiresOptions.after14days'),
		[7]: t('AccessOptions.expiresOptions.after7days'),
		[1]: t('AccessOptions.expiresOptions.after1day'),
	};

	const updateExpiryOptions: ExpiryOptions[] = availableExpiryOptions.map(option => ({
		label: expiryLabels[option],
		value: option,
	}));
	if (!updateExpiryOptions.some(option => option.value === selectedExpiry)) {
		if (selectedExpiry === -1) {
			updateExpiryOptions.push({ label: expiryLabels[-1], value: -1 });
		} else if (!Object.keys(expiryLabels).map(Number).includes(selectedExpiry)) {
			const label = t('AccessOptions.expiresOptions.customDay', {
				days: selectedExpiry,
			});
			updateExpiryOptions.push({ label, value: selectedExpiry });
		}
	}
	updateExpiryOptions.sort((a, b) =>
		a.value === -1 ? -1 : b.value === -1 ? 1 : b.value - a.value
	);
	return updateExpiryOptions;
};

export const getFilteredExpirationOptions = (
	expirationOptions: number[] | undefined,
	accountLevelLinkSettings: any
): number[] => {
	const availableExpirationDays =
		accountLevelLinkSettings.conditionalLink?.shareLinkSettings?.availableExpirationDays;

	const optionsToUse =
		expirationOptions && expirationOptions.length > 0
			? expirationOptions
			: availableExpirationDays;

	return optionsToUse && availableExpirationDays
		? optionsToUse
				.filter((option: any) => availableExpirationDays.includes(option))
				.sort((a: number, b: number) => b - a)
		: [DEFAULT_EXPIRATION_DAYS];
};
